export interface TagParamClick {
    actionClic: string;
    categorieClic: string;
    nomClic: string;
    pageVariante?: {
        pwa?: string;
        etapeCoordonnees?: string;
        nouveauClient?: string;
        typeFormulaire?: string;
        Otis?: string;
    };
}

export type ProductTrackingType = {
    name: string;
    id: string;
    gencode: string;
    price: number;

    ligneProduitNiv1: string;

    ligneProduitNiv2: string;
    gamme: string;
};
export interface TagParamDataLayer {
    pageCategorie: string;
    page: string;
    etapeEcommerce?: string;
    categorieActe?: string;
    panier?: {
        total: {
            base: number;
            recurring: number;
        };
        // type: string;
        // canalVente: string;
        idPanier: string;
        produits: ProductTrackingType[];
        modePaiement?: string;
        idCommande?: string;
    };
    variablesSpecifiques?: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        codeRIO_extrait: string;
    };
    pageVariante?: {
        pwa?: string;
        etapeCoordonnees?: string;
        nouveauClient?: string;
        typeFormulaire?: string;
        Otis?: string;
        abtestOptions?: string;
    };
}

export enum TagEventType {
    DATA = 'data-layer-ready',
    CLICK = 'clic',
    IMPRESSION = 'imp',
}

type OauthConfig =
    | {
          url: string;
          clientId: string;
          callback: string;
      }
    | {
          idToken: string;
          accessToken: string;
      }
    | {
          id_personne: string;
          user_type: string;
          accessToken: string;
      };

export type TagCommanderType = {
    setup: (config: {
        host: string;
        debug: boolean;
        env: 'TEST' | 'PROD';
        site: string;
        shouldEmitEvents?: boolean;
        hasHistory?: boolean;
        oauth?: OauthConfig;
    }) => Promise<void>;

    send: (data: {
        site: string;
        univers: string;
        page: string;
        parcours: string;
        pageCategorie?: string;
        actionClic?: string;
        categorieClic?: string;
        nomClic?: string;
        ligneMarche?: string;
        etapeEcommerce?: string;
        activiteB2BouB2C?: string;
        variablesSpecifiques?: Record<string, string | boolean | number>;
        url?: string;
        [key: string]: string | boolean | number | Record<string, string | boolean | number> | undefined;
    }) => Promise<void>;
};
